import { api } from './api'

/**
 * Descarga de documentos clínicos (P4). Los archivos **no** se sirven como
 * estáticos: se piden a la API con el token de sesión en la cabecera y se
 * materializan como `blob:` en memoria del navegador. Por eso no hay ninguna
 * URL del documento que se pueda copiar, compartir o dejar en el historial.
 */
export type DocumentSource = 'staff' | 'patient'

function fileUrl(source: DocumentSource, id: string): string {
  return source === 'patient' ? `/patient-portal/documents/${id}/file` : `/patient-documents/${id}/file`
}

/** Trae el archivo autenticado y devuelve una URL temporal en memoria. */
export async function fetchDocumentObjectUrl(source: DocumentSource, id: string): Promise<string> {
  const { data } = await api.get<Blob>(fileUrl(source, id), {
    params: { disposition: 'inline' },
    responseType: 'blob',
  })
  return URL.createObjectURL(data)
}

/** Descarga el archivo al equipo con su nombre original. */
export async function downloadDocument(source: DocumentSource, id: string, fileName: string): Promise<void> {
  const { data } = await api.get<Blob>(fileUrl(source, id), {
    params: { disposition: 'attachment' },
    responseType: 'blob',
  })
  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  // El objeto se libera al ciclo siguiente: revocarlo de inmediato cancela
  // la descarga en algunos navegadores.
  setTimeout(() => URL.revokeObjectURL(url), 10_000)
}
